import { Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import {
	getActiveVehicleNoListByStockholder,
	getVehicleNoList,
} from "../../../Slice/veichleSlice.slice";
import { ButtonCompo } from "../../../components/Comman/Button";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import { withRouter } from "../../../components/withRouter";
import endpoint from "../../../config/endpoints";
import {
	areYouSureMsg,
	saveFailedMsg,
	saveWarningMsg,
	savemsg,
	serverMsg,
	vehicleNoMsg,
} from "../../../config/messageconstant";
import { apiPost } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import OfferDetailsOnBillingPreview from "../../Order History/OfferDetailsOnBillingPreview";
import PopUpForPdfForOutletInvoicing from "../../OrderList/PopUpForPdfForOutletInvoicing";
import {
	DEFAULT_VEHICLE_API_FLAG,
	LS_IS_CALL_GET_ALL_VEHICLE,
	LS_STOCK_LIST,
} from "../constants/advanceOutletInvoicingConstants";
import { primaryActionButtonSx } from "../styles/advanceOutletInvoicingStyles";
import "../styles/advanceOutletInvoicingColorVars";
import "../styles/advanceOutletInvoicing.css";
import "../../Order History/OfferDetailsOnBillingPreview.css";
import {
	applyBillCdChange,
	applyItemDiscAmtChange,
	applyItemDiscPerChange,
	buildBillDataToSave,
	deductFreeQtyFromStock,
} from "../utils/billingPreviewCalculations";
import {
	buildOfferCheckboxesForBill,
	buildSelectedOffersPayload,
	hasAnyOfferApplicable,
	isOfferApplicableOnBill,
	partitionOfferCheckboxData,
	getOfferCheckboxGroup,
	toggleOfferCheckboxSelection,
} from "../utils/billingPreviewOfferHelpers";
import { getBillingPreviewFeatureFlags } from "../utils/aoiLocalSettings";
import { mapOfferBillResponse } from "../utils/advanceOutletInvoicingUtils";
import BillingPreviewBillCard from "./BillingPreviewBillCard";
import BillingPreviewVehicleBar from "./BillingPreviewVehicleBar";
import OfferCheckboxCards from "./OfferCheckboxCards";
import OfferSelectionDialog from "./OfferSelectionDialog";

class AdvanceBillingWithOffer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			openDialog: false,
			checkboxAllData: [],
			offerBillNewData: props.offerBillData || [],
			billOfferId: "",
			vehicleNo: "",
			name: "",
			formErrors: {},
			stockChangedList: [],
			offerDetailPopUpFlag: false,
			orderOfferId: "",
			openPdfPopUpFlag: false,
			pdfData: "",
			showOfferHintNote: true,
			offerHintFading: false,
		};
		this.offerHintFadeTimer = null;
		this.offerHintHideTimer = null;
	}
	async componentDidMount() {
		const {
			getActiveVehicleNoListByStockholder,
			getVehicleNoList,
			offerBillData,
			flag,
			showLoador,
			showNotification,
		} = this.props;

		const hasOfferBillData =
			Array.isArray(offerBillData) && offerBillData.length > 0;

		if (!hasOfferBillData) {
			showLoador({ loador: true });
		}

		const isCallGetAllVehicleApiAtOutletinvoicing =
			localStorage.getItem(LS_IS_CALL_GET_ALL_VEHICLE) !== null
				? localStorage.getItem(LS_IS_CALL_GET_ALL_VEHICLE)
				: DEFAULT_VEHICLE_API_FLAG;

		if (isCallGetAllVehicleApiAtOutletinvoicing == 1) {
			await getVehicleNoList().then(({ success }) => {
				if (!success) {
					showNotification({ msg: serverMsg, severity: "error" });
				}
			});
		} else {
			await getActiveVehicleNoListByStockholder().then(({ success }) => {
				if (!success) {
					showNotification({ msg: serverMsg, severity: "error" });
				}
			});
		}

		const nextState = {
			offerBillNewData: offerBillData || [],
		};

		if (flag && hasOfferBillData) {
			const stockCurrentList = localStorage.getItem(LS_STOCK_LIST);
			const valuesArray = JSON.parse(stockCurrentList);
			nextState.stockChangedList = deductFreeQtyFromStock(
				valuesArray,
				offerBillData,
			);
		}

		this.setState(nextState, () => {
			showLoador({ loador: false });
			if (hasAnyOfferApplicable(nextState.offerBillNewData)) {
				this.startOfferHintNoteTimer();
			} else {
				this.setState({ showOfferHintNote: false, offerHintFading: false });
			}
		});
	}

	componentWillUnmount() {
		this.clearOfferHintNoteTimers();
	}

	clearOfferHintNoteTimers = () => {
		if (this.offerHintFadeTimer) {
			clearTimeout(this.offerHintFadeTimer);
			this.offerHintFadeTimer = null;
		}
		if (this.offerHintHideTimer) {
			clearTimeout(this.offerHintHideTimer);
			this.offerHintHideTimer = null;
		}
	};

	startOfferHintNoteTimer = () => {
		this.clearOfferHintNoteTimers();
		this.setState({ showOfferHintNote: true, offerHintFading: false });
		this.offerHintFadeTimer = setTimeout(() => {
			this.setState({ offerHintFading: true });
			this.offerHintHideTimer = setTimeout(() => {
				this.setState({
					showOfferHintNote: false,
					offerHintFading: false,
				});
			}, 1000);
		}, 9000);
	};
	clickSubmitOfferHandler = () => {
		const { offerBillNewData, name } = this.state;
		const {
			billDate,
			redirect,
			showLoador,
			showNotification,
			stockProductData,
		} = this.props;
		const { isShowBillDiscountAndCD: isShowBillDiscountAndCDAtManualOrderBilling } =
			getBillingPreviewFeatureFlags();
		const parseDiscountFields =
			isShowBillDiscountAndCDAtManualOrderBilling;
		const dataToSave = offerBillNewData.map((billObject) =>
			buildBillDataToSave(billObject, name, parseDiscountFields),
		);

		const selectList = [];
		if (stockProductData.length !== 0) {
			stockProductData.map((uncheckedObjct) => {
				selectList.push(uncheckedObjct.id);
			});
		}

		if (this.checkValidation()) {
			const idsList = dataToSave.map((item) => item.id);

			swal({
				title: areYouSureMsg,
				text: saveWarningMsg,
				icon: "warning",
				buttons: true,
				dangerMode: true,
			}).then(async (willDelete) => {
				if (willDelete) {
					if (selectList.length !== 0) {
						const jsonData = {
							outletOrderDetailIds: selectList,
							isBillGenerate: "2",
						};
						showLoador({ loador: true });
						await apiPost({
							url:
								endpoint.outletBillHeader +
								"/save-list-after-appying-offers-optimize?billDate=" +
								billDate,
							postBody: dataToSave,
						}).then(async ({data, success }) => {
							if (data?.data?.error) {
								showNotification({
									msg: data?.data?.message ?? saveFailedMsg,
									severity: "error",
								});
							} else {
								showNotification({ msg: savemsg });

								await apiPost({
									url:
										endpoint.outletOrderDetail +
										"/update-is-bill-generate-status",
									postBody: jsonData,
								}).then(({ success }) => {
									if (success) {
										if (redirect) {
											window.location.replace(
												"/functional-dashboard-distributor",
											);
										} else {
											this.setState({
												openPdfPopUpFlag: true,
												pdfData: idsList,
											});
										}
									}
								});
							}
						});
						showLoador({ loador: false });
					} else {
						showLoador({ loador: true });
						await apiPost({
							url:
								endpoint.outletBillHeader +
								"/save-list-after-appying-offers-optimize?billDate=" +
								billDate,
							postBody: dataToSave,
						}).then(({ data, success }) => {
							if (data?.data?.error) {
								showNotification({
									msg: data?.data?.message ?? saveFailedMsg,
									severity: "error",
								});
							} else {
								showNotification({ msg: savemsg });

								if (redirect) {
									window.location.replace("/functional-dashboard-distributor");
								} else {
									this.setState({ openPdfPopUpFlag: true, pdfData: idsList });
								}
							}
						});
						showLoador({ loador: false });
					}
				}
			});
		}
	};

	clickSubmitHandler = () => {
		const { checkboxAllData, offerBillNewData, billOfferId, stockChangedList } =
			this.state;
		if (offerBillNewData.length !== 0) {
			const payload = buildSelectedOffersPayload({
				offerBillNewData,
				billOfferId,
				checkboxAllData,
				stockChangedList,
			});
			if (payload) {
				this.onSave(payload);
			}
		}
	};

	onSave = async (dataToSave) => {
		const { offerBillNewData, openDialog } = this.state;
		const { flag, showLoador, showNotification } = this.props;
		const stockCurrentList = localStorage.getItem(LS_STOCK_LIST);
		const valuesArray = JSON.parse(stockCurrentList);

		showLoador({ loador: true });
		await apiPost({
			url: endpoint.outletBillHeader + "/apply-offer-with-new-offers-optimize",
			postBody: dataToSave,
		}).then(({ data, success }) => {
			if (success) {
				const responseBillId =
					data.data.outletBillHeader?.id ??
					data.data.outletBillsAfterApplyingOffers?.id;
				const newOfferData = offerBillNewData.map((offerNewObject) => {
					const currentBillId =
						offerNewObject.outletBillHeader?.id ??
						offerNewObject.outletBillsAfterApplyingOffers?.id;
					if (currentBillId == responseBillId) {
						return data.data;
					}
					return offerNewObject;
				});

				if (flag) {
					this.setState({
						stockChangedList: deductFreeQtyFromStock(valuesArray, newOfferData),
					});
				}

				const newObjectToSave = mapOfferBillResponse(newOfferData);
				showNotification({ msg: savemsg });

				this.setState({
					offerBillNewData: newObjectToSave,
					openDialog: !openDialog,
				});
			} else {
				showNotification({ msg: saveFailedMsg, severity: "error" });
			}
		});
		showLoador({ loador: false });
	};

	onCheckBoxClick = (checkedValue, headerId) => {
		const { checkboxAllData, offerBillNewData } = this.state;
		this.setState({
			checkboxAllData: toggleOfferCheckboxSelection(
				checkboxAllData,
				offerBillNewData,
				checkedValue,
				headerId,
			),
		});
	};

	clickHandler = (billId) => {
		const { openDialog, offerBillNewData } = this.state;
		this.setState({
			openDialog: !openDialog,
			checkboxAllData: [],
			billOfferId: billId,
		});
		this.setState({
			checkboxAllData: buildOfferCheckboxesForBill(offerBillNewData, billId),
		});
	};

	offerHandleCellClick = (dataOrOfferId) => {
		const offerId =
			typeof dataOrOfferId === "object" ? dataOrOfferId?.id : dataOrOfferId;
		if (!offerId) return;
		this.setState({ orderOfferId: offerId, offerDetailPopUpFlag: true });
	};

	handleItemDiscPerChange = (billHeaderId, detailId, event) => {
		this.onChangeTextField(billHeaderId, detailId)(event);
	};

	handleItemDiscAmtChange = (billHeaderId, detailId, event) => {
		this.onChangeTextFieldItemDiscountAmt(billHeaderId, detailId)(event);
	};

	toggleOfferDetailsPopup = () => {
		this.setState({ offerDetailPopUpFlag: false, orderOfferId: "" });
	};

	checkValidation = () => {
		const { vehicleNo } = this.state;
		const formErrors = {};
		let formIsValid = true;

		if (vehicleNo === "") {
			formIsValid = false;
			formErrors["vehicleNoError"] = vehicleNoMsg;
		}
		this.setState({ formErrors });
		return formIsValid;
	};
	changeHandler = (e, value) => {
		const selectedVehicles = this.props.vehicleList?.vehicle.filter(
			(row) => row.id === value,
		);
		if (selectedVehicles && selectedVehicles.length > 0) {
			const selectedVehicle = selectedVehicles[0];
			this.setState({
				vehicleNo: value,
				name: selectedVehicle.name,
			});
		}
	};

	updateOfferBillData = (billHeaderId, updateFn) => {
		const { offerBillNewData } = this.state;
		this.setState({
			offerBillNewData: offerBillNewData.map((billObject) => {
				if (billObject.outletBillsAfterApplyingOffers?.id === billHeaderId) {
					return {
						...billObject,
						outletBillsAfterApplyingOffers: updateFn(
							billObject.outletBillsAfterApplyingOffers || {},
						),
					};
				}
				return billObject;
			}),
		});
	};

	onChangeTextField = (billHeaderId, id) => (event) => {
		const { name, value } = event.target;
		const billObject = this.state.offerBillNewData.find(
			(bill) => bill.outletBillsAfterApplyingOffers?.id === billHeaderId,
		);
		const updatedBill = applyItemDiscPerChange(
			billObject?.outletBillsAfterApplyingOffers || {},
			id,
			name,
			value,
		);
		if (updatedBill) {
			this.updateOfferBillData(billHeaderId, () => updatedBill);
		}
	};

	onChangeTextFieldItemDiscountAmt = (billHeaderId, id) => (event) => {
		const { value } = event.target;
		const billObject = this.state.offerBillNewData.find(
			(bill) => bill.outletBillsAfterApplyingOffers?.id === billHeaderId,
		);
		const updatedBill = applyItemDiscAmtChange(
			billObject?.outletBillsAfterApplyingOffers || {},
			id,
			value,
		);
		if (updatedBill) {
			this.updateOfferBillData(billHeaderId, () => updatedBill);
		}
	};

	changeHandlerTextField = (billHeaderId, _dataKey, id) => (event) => {
		const { name, value } = event.target;
		const billObject = this.state.offerBillNewData.find(
			(bill) => bill.outletBillsAfterApplyingOffers?.id === billHeaderId,
		);
		const updatedBill = applyBillCdChange(
			billObject?.outletBillsAfterApplyingOffers || {},
			id,
			name,
			value,
		);
		if (updatedBill) {
			this.updateOfferBillData(billHeaderId, () => updatedBill);
		}
	};

	renderOfferCheckbox = (type, level) => (
		<OfferCheckboxCards
			items={getOfferCheckboxGroup(this.offerCheckboxGroups, type, level)}
			onCheckBoxClick={this.onCheckBoxClick}
		/>
	);

	getBillingFlags = () => getBillingPreviewFeatureFlags();

	render() {
		const {
			openDialog,
			checkboxAllData,
			offerBillNewData,
			vehicleNo,
			formErrors,
			offerDetailPopUpFlag,
			orderOfferId,
			openPdfPopUpFlag,
			pdfData,
			showOfferHintNote,
			offerHintFading,
		} = this.state;
		const { onCancel, vehicleList } = this.props;
		const {
			isShowBillDiscountAndCD,
			showDiscountAmtEditable,
			isDetailedBillingView,
		} = this.getBillingFlags();
		this.offerCheckboxGroups = openDialog
			? partitionOfferCheckboxData(checkboxAllData)
			: null;

		return (
			<>
				<Paper
					sx={{
						p: 1.5,
						borderRadius: 1.5,
					}}
					elevation={0}
					className="billing-preview-page"
				>
					<LandingScreenHeader
						screenTitle={"Billing Preview"}
						showTable={false}
						showBackButton={true}
						showAddButton={false}
						onCancel={onCancel}
					/>

					{offerBillNewData.length !== 0 && (
						<div className="billing-preview-bills-list">
							{offerBillNewData.map((billData, index) => (
								<BillingPreviewBillCard
									key={
										billData.outletBillsAfterApplyingOffers?.id || index
									}
									billData={billData}
									index={index}
									totalBills={offerBillNewData.length}
									showOfferIcon={isOfferApplicableOnBill(billData)}
									showOfferHintNote={showOfferHintNote}
									offerHintFading={offerHintFading}
									isShowBillDiscountAndCD={isShowBillDiscountAndCD}
									showDiscountAmtEditable={showDiscountAmtEditable}
									isDetailedBillingView={isDetailedBillingView}
									formErrors={formErrors}
									onOfferClick={this.clickHandler}
									onOfferDetailClick={this.offerHandleCellClick}
									onChangeItemDiscPer={this.handleItemDiscPerChange}
									onChangeItemDiscAmt={this.handleItemDiscAmtChange}
									onChangeBillCd={this.changeHandlerTextField}
								/>
							))}
						</div>
					)}

					<BillingPreviewVehicleBar
						vehicleNo={vehicleNo}
						vehicleOptions={vehicleList?.vehicle}
						formErrors={formErrors}
						onChange={this.changeHandler}
					/>

					{openDialog && (
						<OfferSelectionDialog
							open={openDialog}
							onClose={this.clickHandler}
							checkboxAllData={checkboxAllData}
							onSubmit={this.clickSubmitHandler}
							renderOfferCheckbox={this.renderOfferCheckbox}
						/>
					)}

					{offerDetailPopUpFlag && (
						<OfferDetailsOnBillingPreview
							orderOfferId={orderOfferId}
							onClose={this.toggleOfferDetailsPopup}
							showEnhancedOfferUI
						/>
					)}

					<div className="billing-preview-footer">
						<ButtonCompo
							sx={primaryActionButtonSx}
							size="medium"
							type="button"
							variant="contained"
							name={"Save Bill"}
							onClick={this.clickSubmitOfferHandler}
							fullWidth={false}
						/>
					</div>

					{openPdfPopUpFlag && (
						<PopUpForPdfForOutletInvoicing
							open={openPdfPopUpFlag}
							pdfData={pdfData}
							backRoute="/advance-outlet-invoicing"
						/>
					)}
				</Paper>
			</>
		);
	}
}
const mapStateToProps = (state) => ({ vehicleList: state.vehicle });
const mapDispatchToProps = {
	getActiveVehicleNoListByStockholder,
	getVehicleNoList,
	showLoador,
	showNotification,
};
export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(AdvanceBillingWithOffer);
